import { ImageLoader } from 'next/dist/client/image';

import { convertImgixURL } from '@/utils/imgixUtils';

export const imgixOptimizedLoader: ImageLoader = ({ src, width, quality }) => {
  return convertImgixURL(src, { w: width, q: quality, auto: 'compress' });
};

export const imgixOriginalLoader: ImageLoader = ({ src, width, quality }) => {
  return convertImgixURL(src, { w: width, q: quality });
};
